import { useEffect, useState } from "react";
import Table from "../common/table";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";
import { format } from "date-fns";
import { orderBy } from "../../funcs";
import apiBombasVacuo from "../../services/apis/apiBombaVacuo";

export default function BombasVacuo() {

    const [leituras, setLeituras] = useState([]);
    const unidadeId = getCurrentUnidadeId();

    useEffect(() => {
        (async () => {
            const res = await apiBombasVacuo.findAll(unidadeId);
            const bombas = res.data;
            const leituraBombas = bombas.map(({leiturasBombasVacuo}) => (leiturasBombasVacuo[0]));                
            orderBy(leituraBombas, "bombaVacuoId");
            setLeituras(leituraBombas);
        })();
    },[unidadeId]);

    return 	<div className="w-full">
        <Table.Root>
            <Table.Head>
                <Table.Header>BB id</Table.Header>
                <Table.Header>Ligado</Table.Header>
                <Table.Header>Data hora</Table.Header>
                <Table.Header>Corrente</Table.Header>
                <Table.Header>Frequência</Table.Header>
                <Table.Header>Potência Calculada</Table.Header>
            </Table.Head>
            <Table.Body>
                {leituras.map(
                    (leitura) => (
                        <Table.Row
                            key={leitura.id}
                        >
                            <Table.Data>{leitura.bombaVacuoId}</Table.Data>
                            <Table.Data>{leitura.ligado ? "on" : "off"}</Table.Data>
                            <Table.Data>{format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss")}</Table.Data>
                            <Table.Data>{leitura.corrente}</Table.Data>
                            <Table.Data>{leitura.frequencia}</Table.Data>
                            <Table.Data>{leitura.potenciaCalculada}</Table.Data>
                        </Table.Row>
                    )
                )}
            </Table.Body>
        </Table.Root>
    </div>
}